import { Button, Form, Input,InputNumber, Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import api from '../../../../../apis';
import { useNavigate } from 'react-router-dom';
import UtradeAgreement from './UtradeAgreement';

import { showMessageModal, showSuccessMessageModal } from '../../../../../components/utils';

const Index = () => {

    const [currentStep, setCurrentStep] = useState("agreement");
    const navigate = useNavigate();
    const [ loading, setLoading ] = useState(false);
    const [form] = Form.useForm();
    const [doneCaptcha, setDoneCaptcha] = useState(false);

    const [passwordRules, setPasswordRules] = useState([{ 
        required: true, message: 'Please input your password' 
    },{
        
        pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,15}$/,
        message: <div>
            Password must meet ALL of the requirements
        </div>,
    
    }]);

    const [passwordRulesText, setPasswordRulesText] = useState(<div className='d-flex w-100'>
        <div className=''>
            Password must meet ALL of the following requirements ONLY:
            <br/>
            8-15 characters
            <br/>
            At least one Alphabet (Uppercase)
            <br/>
            At least one Alphabet (Lowercase)
            <br/>
            At least one Number
            <br/>
            At least one Symbol
        </div>
    </div>);

    useEffect(() => {
        requestPasswordRules();

    }, []);

    const onFinish = (v: any) => {
        
        let param =   {
            "username": v.username,
            "password": v.password,
            "type": Number(v.type),
            "identity": v.identity,
            "email": v.email,
            "answers": [v.question1, v.question2, v.question3]
        }

        console.log('Success:param', param);
        handleRegister(param);
        
    };

    const requestPasswordRules = async () => {
        let result = await api.userPasswordRules();
        if(result.rules){
            let newRules = [
                {
                    required: true, message: 'Please input your password'
                }
            ];

            let newRulesText = [];

            // {
            //     "alphabet": true,
            //     "numeric": true,
            //     "symbol": true,
            //     "sensitive": true,
            //     "min": 8,
            //     "max": 20
            // }

            let r = result.rules;

            if(r.min && r.max){
                let min = r.min;
                let max = r.max;

                newRules.push({
                    pattern:  `^.{${min},${max}}$`,
                    message: `${min}-${max} characters`
                });

                newRulesText.push(<div>{min}-{max} characters</div>)
            }

            if(r.alphabet){
                if(r.sensitive){
                    newRules.push({
                        pattern:  /[A-Z]/,
                        message: 'At least one Alphabet (Uppercase)'   
                    });

                    newRules.push({
                        pattern:  /[a-z]/,
                        message: 'At least one Alphabet (Lowercase)'   
                    });

                    newRulesText.push(<div>At least one Alphabet (Uppercase)</div>)
                    newRulesText.push(<div>At least one Alphabet (Lowercase)</div>)

                }else{
                    newRules.push({
                        pattern:  /[A-Za-z]/,
                        message: 'At least one Alphabet'
                    });
                    newRulesText.push(<div>At least one Alphabet</div>)
                }
               
            }

            if(r.numeric){
                newRules.push({
                    pattern:  /\d/,
                    message: 'At least one Number'
                });

                newRulesText.push(<div>At least one Number</div>)
            }

            if(r.symbol){
                newRules.push({
                    pattern:  /[\W_]/,
                    message: 'At least one Symbol'
                });

                newRulesText.push(<div>At least one Symbol</div>)
            }

            setPasswordRules(newRules);
            setPasswordRulesText(<div className='d-flex w-100'>
                <div className=''>
                    Password must meet ALL of the following requirements ONLY:
                    {newRulesText}
                </div>
            </div>);
        }
    }
    

    const handleRegister = async (param:any) => {
         
        setLoading(true);
        param.mode = 1;//edoc

        let result = await api.userRegister(param);
 
         if (result != false && result.status == 0) {
          //  alert("Register successful, please check your mailbox to activate your account");
            showSuccessMessageModal("Register successful, please check your mailbox to activate your account");
             //window.location.reload();
             navigate('/login');
         } else {
             setLoading(false);
         }
     };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    const validateConfirmPassword = (_: any, value: any) => {
        if (!value || form.getFieldValue('password') === value) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('The two passwords that you entered do not match!'));
    };

    const [selection, setSelection] = useState('0'); // Default selection
    const onSelectionChange = (e: any) => {
        setSelection(e.target.value);
    };

    const onCaptchaChange = (value:any)=>{
        console.log("Captcha value:", value);
        setDoneCaptcha(true);
    }

    const handleNRICChange = (e:any) => {
        const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9]/g, ""); // Remove non-alphanumeric characters
        form.setFieldsValue({ identity: sanitizedValue }); // Update field value in the form
    };
      
    return (
        <> 
            {currentStep == "agreement" &&
            <UtradeAgreement onNextStep={() => setCurrentStep("register-account")} />
            }
            {
                currentStep == "register-account" &&
                <div className='page-layout w-100 d-flex pt-5 justify-content-center align-items-center  register-form'>
                   
                   
                    <Form
                        form={form}
                        name="basic"
                        labelCol={{ span: 12 }}
                        wrapperCol={{ span: 12 }}
                        initialValues={{ 
                            type:"0"
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        style={{
                            width:"100%",
                            maxWidth:"1200px"
                        }}
                    >
                        <div className='title'>Account Information</div>
                        <div className='pt-3'></div>
                        <Form.Item
                            label="User ID"
                            name="username"
                            rules={[{ required: true, message: 'Please input your username' }]}
                        >
                            <Input />
                        </Form.Item>
                
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={passwordRules}
                        >
                            <Input.Password />
                        
                        </Form.Item>
                        
                        
                        <Form.Item
                            label="Confirm Password"
                            name="confirm-password"
                            validateTrigger="onBlur"
                            rules={[
                                { 
                                    required: true, message: 'Please input your confirm password',
                                },
                            { validator: validateConfirmPassword }
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item wrapperCol={{lg:{ offset: 12, span: 12 }}} >
                            {passwordRulesText}
                        </Form.Item>
                    

                        <div className='title'>Member Information</div>
                        <div className='pt-3'></div>

                        {/* <Form.Item
                            label="NRIC"
                            name="nric"
                            rules={[
                                { 
                                    required: true, message: 'Please input your nric',
                                },
                                {
                                    pattern: /^\d+$/,
                                    message: 'Only numbers are allowed!',
                                },
                            ]}
                        >
                            <div className='d-flex h-100'>
                                <div className='col-4'><Form.Item   name="nric-1"><Input maxLength={6}/></Form.Item></div>
                                <div className='col-1'> <div className='pt-1'>-</div> </div>
                                <div className='col-3'><Form.Item name="nric-2"><Input maxLength={2}/></Form.Item></div>
                                <div className='col-1'> <div className='pt-1'>-</div> </div>
                                <div className='col-3'><Form.Item><Input maxLength={4}/></Form.Item></div>
                            </div>
                        </Form.Item> */}

                        <Form.Item
                            label="Select Registration Type"
                            name="type"
                            rules={[{ required: true, message: 'Please select an option!' }]}
                        >
                            <Radio.Group onChange={onSelectionChange}>
                            <Radio value="0">Individual</Radio>
                            <Radio value="1">Corporate</Radio>
                            </Radio.Group>
                        </Form.Item>
                            {selection}
                        {selection === '0' && (
                            <>
                            <Form.Item
                                label="NRIC/Passport"
                                name="identity"
                                rules={[{ required: true, message: 'Please enter your NRIC/Passport' }]}
                                extra={<div style={{ color: 'blue' }}>Kindly enter NRIC/Passport Number without hyphen</div>}
                            >
                                <Input placeholder="Enter your NRIC/Passport" onChange={handleNRICChange}/>
                            </Form.Item>
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                { required: true, message: 'Please enter your email' },
                                { type: 'email', message: 'Please enter a valid email address!' },
                                ]}
                            >
                                <Input placeholder="Enter your email" />
                            </Form.Item>
                            </>
                        )}

                        {selection === '1' && (
                            <>
                            <Form.Item
                                label="Business Registration"
                                name="identity"
                                rules={[{ required: true, message: 'Please enter your Business Registration!' }]}
                            >
                                <Input placeholder="Enter your Business Registration" onChange={handleNRICChange} />
                            </Form.Item>
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                { required: true, message: 'Please enter your email!' },
                                { type: 'email', message: 'Please enter a valid email address!' },
                                ]}
                            >
                                <Input placeholder="Enter your email" />
                            </Form.Item>
                            </>
                        )}
                        {/* <Form.Item
                            label="Mobile Number"
                            name="phone_number"
                            rules={[
                                { required: true, message: 'Please input' },
                                {
                                    pattern: /^\d+$/,
                                    message: 'Only numbers are allowed!',
                                },

                            ]}
                        >
                            <Input />
                        </Form.Item> */}
    
                        <div className='title'>Please Provide your answer to the following questions:</div>
                        <div className='pt-3'></div>
                        <Form.Item
                            label="1. What is your mother's maiden name?"
                            name="question1"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="2. What is your favourite past time?"
                            name="question2"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="3. What is your first job after school?"
                            name="question3"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                            <Input />
                        </Form.Item>

                        {/* <div className='d-flex justify-content-center'>
                            <ReCAPTCHA
                                sitekey="6Ld1-DMqAAAAAMBuJ8M1G0tV2dJdzaVWTkpYq_9h"
                                onChange={onCaptchaChange}
                            />
                        </div> */}
        
                        
                            {/* {
                                doneCaptcha &&
                                <Form.Item wrapperCol={{ offset: 8, span: 16 }} className='pt-4'>
                                    <div>
                                        <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md'>
                                            Submit
                                        </Button>
                                    </div>
                                </Form.Item>
                            } */}

                        <Form.Item wrapperCol={{lg:{ offset: 8, span: 16 }}} className='pt-4'>
                            <div>
                                <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md' loading={loading}>
                                    Submit
                                </Button>
                            </div>
                        </Form.Item>
                        
                    </Form>
                </div>
            }
            
        </>
    );
};

export default Index;
